import { useEffect, useRef, useState } from "react"

import { getProjectSuggestions } from "@/lib/api"

/** Starter prompts for the active project; re-fetched when the project or its document count changes. */
export function useProjectStarters(projectId: string | null, referenceCount: number, modelId: string | null) {
  const [state, setState] = useState<{ projectId: string; prompts: string[] } | null>(null)
  const modelRef = useRef(modelId)
  modelRef.current = modelId

  useEffect(() => {
    if (!projectId) return
    let cancelled = false
    getProjectSuggestions(projectId, modelRef.current)
      .then((prompts) => { if (!cancelled) setState({ projectId, prompts }) })
      .catch(() => { if (!cancelled) setState({ projectId, prompts: [] }) })
    return () => { cancelled = true }
  }, [projectId, referenceCount])

  if (!projectId) return { prompts: [], loading: false }
  // Stale results from another project must never show; until this project's fetch lands, we are loading.
  if (state?.projectId !== projectId) return { prompts: [], loading: true }
  return { prompts: state.prompts, loading: false }
}
